/* rb-b-ready.js — reveal the filter panel once the modules have rearranged it.
   LOADED LAST of the scripts.

   rb-b-cls.css holds .collection-sidebar at visibility:hidden while
   <html> carries .rbb-boot, so the half-built panel is never painted and
   therefore cannot contribute to CLS. This adds .rbb-ready to reveal it.

   WHY DOMContentLoaded IS THE RIGHT MOMENT: every rb-b-* module is a deferred
   script, and deferred scripts run IN ORDER and finish before DOMContentLoaded
   fires. So by the time this listener runs, sizeclean, shoes, pants and the
   rest have all completed their first pass. The extra requestAnimationFrame
   lets the resulting layout settle in the same frame it is revealed.

   THE FAILSAFE IS NOT OPTIONAL. If any earlier module throws before its boot
   completes, the panel must still appear — an invisible filter is far worse
   than a visible shift. The timeout reveals it regardless. Note the separate
   no-JS guard: .rbb-boot is added by an inline script in the loader, so with
   scripting off the hide rule never applies in the first place. */

(function () {
  'use strict';

  var done = false;

  function reveal() {
    if (done) return;
    done = true;
    document.documentElement.classList.add('rbb-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.requestAnimationFrame(reveal);
    });
  } else {
    window.requestAnimationFrame(reveal);
  }

  setTimeout(reveal, 2000);   // never leave the panel hidden
})();
